<div class="filter">
    <mat-form-field>
        <input
            matInput
            type="text"
            (keyup)="doFilter($event.target.value)"
            placeholder="Filtrer"
        />
    </mat-form-field>
</div>
<table mat-table class="tab-content" [dataSource]="dataSource"
    matSort matSortActive="fullLabel" matSortDirection="asc" matSortDisableClear>
    <!-- City Column -->
    <ng-container matColumnDef="fullLabel">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.city.shortLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td
                class="labelButton"
                mat-cell
                *matCellDef="let element"
                (click)="loadCityDetails(element.id)"
            >
                {{ element.fullLabel.replace("(bbc2020)", "") }}
            </td>
        </tr>
    </ng-container>

    <!-- Realized Column -->
    <ng-container matColumnDef="lastRealizedYear">
        <tr>
            <th
                class="labelNumberHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.realizedYear.shortLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowNumber" mat-cell *matCellDef="let element">
                {{ element.lastRealizedYear }}
            </td>
        </tr>
    </ng-container>

    <!-- MJP Column -->

    <ng-container matColumnDef="lastMJPYear">
        <tr>
            <th
                class="labelNumberHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.mjpYear.shortLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowNumber" mat-cell *matCellDef="let element">
                {{ element.lastMJPYear }}
            </td>
        </tr>
    </ng-container>

    <!-- ImportDate Column -->
    <ng-container matColumnDef="importDate">
        <tr>
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="labelTextHeader"
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.importDate.shortLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowText" mat-cell *matCellDef="let element">
                {{ element.importDate | date: "dd/MM/yyyy" }}
            </td>
        </tr>
    </ng-container>

    <!-- Licence -->
    <ng-container matColumnDef="licenceType">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.licence.shortLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowText" mat-cell *matCellDef="let element">
                {{ element.licenceType }}
            </td>
        </tr>
    </ng-container>

    <!-- LAST CONNEXION DATE -->
    <ng-container matColumnDef="lastConnexionDate">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.dataToBeUpdated.dataListsNames.city.table.connexionDate.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowText" mat-cell *matCellDef="let element">
                {{ element.lastConnexionDate }}
            </td>
        </tr>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
</table>
